import Cells from "./Cells.jsx";

export default Cells;



// WEBPACK FOOTER //
// ./src/components/common/treeTableWithSlider/cells/index.js